import React from 'react';
import { useHistory } from 'react-router-dom';
import { Button, Dropdown } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import { useAuth } from '../../../auth/AuthProvider';
import UserAvatar from '../UserAvatar';
import { useTranslation } from '../../../utils';
import './LogoutDropdown.scss';

const LogoutDropdown: React.FC = () => {
  const { logout, user } = useAuth();
  const translate = useTranslation();
  const history = useHistory();

  const logoutUser = () => {
    logout();
  };

  const goToProfile = () => {
    history.push('/profile');
  };

  // Use firstName/lastName from user, fallback to parsing displayName
  const firstName =
    user?.firstName || (user?.displayName ? user.displayName.split(' ')[0] : '') || '';
  const lastName =
    user?.lastName ||
    (user?.displayName ? user.displayName.split(' ').slice(1).join(' ') : '') ||
    '';

  const menuItems = [
    {
      key: 'profile',
      label: translate('form.profile'),
      onClick: goToProfile,
    },
    {
      key: 'logout',
      label: translate('form.logout'),
      onClick: logoutUser,
    },
  ];

  return (
    <Dropdown
      menu={{ items: menuItems }}
      trigger={['click']}
      placement="bottomLeft"
      className="user-dropdown"
    >
      <Button>
        <UserAvatar firstName={firstName} lastName={lastName} />
        {firstName || (user?.email || '').split('@')[0]}
        <DownOutlined />
      </Button>
    </Dropdown>
  );
};

export default LogoutDropdown;
